export default {
  "path": "/demo/field-matching",
  "meta": {
    "name": "demo-字段匹配",
    "title": "字段匹配",
    "isComponentDoc": true,
    "category": "Introduce"
  }
};